module.exports = __webpack_public_path__ + "images/867e897cf235ee30862c48e7474c3846.png";